import React from 'react';
import Preparing from '../../components/Preparing/Preparing';

const ChipPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>칩착용법</div>
            <hr  className=' ml-28 mr-28'/>
            <Preparing/>
        </div>
    );
};

export default ChipPage;